import _ from 'underscore';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { TopKeyCardType } from '../constants';
import { getTopKeyCardConfig } from './top-key-card';

const { PaymentOption } = Constants;

export function getTopKeyCardTypes({
  paymentOption, isAccountScope, isCurrentMonth, isLifetimeBudget,
}) {
  if (!isAccountScope) {
    if (isLifetimeBudget) {
      return isCurrentMonth
        ? [TopKeyCardType.SpendToDate, TopKeyCardType.LifetimeBudget]
        : [TopKeyCardType.SpendOfTheMonth, TopKeyCardType.LifetimeBudget];
    }
    return isCurrentMonth
      ? [TopKeyCardType.SpendToDate, TopKeyCardType.MonthlyBudget, TopKeyCardType.DailyBudget]
      : [TopKeyCardType.SpendOfTheMonth, TopKeyCardType.MonthlyBudget];
  }
  if (!isCurrentMonth) {
    switch (paymentOption) {
      case PaymentOption.Prepay:
      case PaymentOption.Threshold:
      case PaymentOption.Invoice:
        return [TopKeyCardType.SumSpendOfTheMonth, TopKeyCardType.SumMonthlyBudget, TopKeyCardType.SumTotalBudget];
      default:
        return null;
    }
  }
  switch (paymentOption) {
    case PaymentOption.Prepay:
      return [TopKeyCardType.SumSpendToDate, TopKeyCardType.SumMonthlyBudget, TopKeyCardType.SumDailyBudget, TopKeyCardType.SumTotalBudget, TopKeyCardType.PrepayBalance];
    case PaymentOption.Threshold:
      return [TopKeyCardType.SumSpendToDate, TopKeyCardType.SumMonthlyBudget, TopKeyCardType.SumDailyBudget, TopKeyCardType.SumTotalBudget, TopKeyCardType.CurrentBalance];
    case PaymentOption.Invoice:
      return [TopKeyCardType.BudgetAndSpend, TopKeyCardType.InsertionOrder];
    default:
      return null;
  }
}

export function getTopKeyCardGroup({
  i18n,
  authzMap,
  currencyCode,
  activity,
  paymentOption,
  isAccountScope,
  isCurrentMonth,
  rawData,
  abnormalStatus,
  isExperimentCampaign,
  openBudgetUpdatePanel,
  navigateBySiteMapId,
}) {
  const cardTypes = getTopKeyCardTypes({
    paymentOption, isAccountScope, isCurrentMonth, isLifetimeBudget: !!rawData?.LifetimeBudget,
  });
  const cardNumber = cardTypes ? cardTypes.length : 0;
  if (!cardTypes) {
    return null;
  }
  return {
    cards: _.compact(_.map(cardTypes, topKeyCardType => getTopKeyCardConfig({
      i18n,
      authzMap,
      currencyCode,
      activity,
      topKeyCardType,
      rawData,
      abnormalStatus,
      isExperimentCampaign,
      openBudgetUpdatePanel,
      navigateBySiteMapId,
    }))),
    cardNumber,
  };
}
